import {Injectable, OnInit} from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import {Observable} from 'rxjs';
import {AppService} from '@services/app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, OnInit {
  userType: string;


  constructor(
    private router: Router,
    private appService: AppService
  ) {

  }

  ngOnInit() {
    this.userType = localStorage.getItem('lfUserType');
    console.log(`check`)
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.getProfile(state.url);
  }


  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.canLoad(state.url);
    console.log(`check auth`)
    return this.canActivate(next, state);
  }

  canLoad(
    route: string
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    console.log(route)
    if (route == "/login") {
      if (this.userType == "ADMIN") {
        this.router.navigate(["/main/dashboard"]);
        return true;
      } else {
        this.router.navigate(["/"]);
        return true;
      }
    }
  }

  async getProfile(route: string) {
    if (route.startsWith('/main')) {
      this.userType = localStorage.getItem('lfUserType');
      return this.userType === 'ADMIN';
    }
  }
}
